"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var collection_1 = require("../utils/collection");

var utils_1 = require("./utils");

var AppHydration =
/** @class */
function () {
  function AppHydration(hydrationKey) {
    this.hydrationKey = hydrationKey;
  }

  AppHydration.prototype.getAppHydration = function (manifest, appParamsHelper) {
    var hydrationId = utils_1.getAppKey(manifest, appParamsHelper);
    var hydrationPoint = this.getHydrationPoint();
    return hydrationPoint && hydrationPoint.appsByKey && hydrationPoint.appsByKey[hydrationId];
  };

  AppHydration.prototype.getManagerHydration = function () {
    var hydrationPoint = this.getHydrationPoint();
    return hydrationPoint && hydrationPoint.manager;
  };

  AppHydration.prototype.mergeAppsResponses = function (appsResponses) {
    var _a, _b;

    var javascriptPieces = [];

    if (appsResponses && appsResponses.length > 0) {
      var merged = {
        apps: []
      };

      for (var _i = 0, appsResponses_1 = appsResponses; _i < appsResponses_1.length; _i++) {
        var appsResponse = appsResponses_1[_i];
        var apps = appsResponse.apps,
            manager = appsResponse.manager,
            translations = appsResponse.translations,
            javascript = appsResponse.javascript;

        if (manager && typeof manager === 'object' && Object.keys(manager).length > 0) {
          merged.manager = manager;
        }

        if (apps && merged.apps) {
          (_a = merged.apps).push.apply(_a, apps);
        }

        if (translations) {
          if (!merged.translations) {
            merged.translations = [];
          }

          (_b = merged.translations).push.apply(_b, translations);
        }

        if (javascript) {
          javascriptPieces.push(javascript);
        }
      }

      if (javascriptPieces && javascriptPieces.length > 0) {
        merged.javascript = javascriptPieces.join('\n');
      }

      return merged;
    }

    return;
  };

  AppHydration.prototype.setHydrationPoint = function (appsResponse) {
    var hydrationPoint = this.getHydrationPoint();

    if (!hydrationPoint) {
      hydrationPoint = {
        appsByKey: {}
      };
    }

    var mergedAppsResponse = this.mergeAppsResponses([hydrationPoint, appsResponse]);
    hydrationPoint = __assign(__assign({}, mergedAppsResponse), {
      appsByKey: __assign(__assign({}, collection_1.pivotCollection(mergedAppsResponse.apps || [], function (appResponse) {
        return appResponse.app.id || 'NO_ID';
      })), collection_1.pivotCollection(mergedAppsResponse.apps || [], function (appResponse) {
        return appResponse.app.id + "|" + appResponse.app.applicationCode;
      }))
    });
    window[this.hydrationKey] = hydrationPoint;
  };

  AppHydration.prototype.getHydrationPoint = function () {
    if (!window[this.hydrationKey]) {
      window[this.hydrationKey] = {};
    }

    return window[this.hydrationKey];
  };

  return AppHydration;
}();

exports.AppHydration = AppHydration;